import React from 'react'
import { useSelector } from 'react-redux'
import { NoBalance } from 'pages/Payments'
import { CreateTestTaker, CreateGrade, CreateClass, CreateTestTakers } from 'pages'
import { CreateAffliation } from 'pages'
import { alerts as alertKeys } from 'keys'
import { BackToConfirmation } from 'pages/Admin/TranscriptionSystem/AdminAssessments'
import { AssessmentCompletionAlert, RecordInstructions } from 'components/School/MakingRecordAssessments'
import { InitializeConfirmation } from 'pages/Admin/TranscriptionSystem/MarkingWords'
import { CreateCoupon } from 'pages/Coupon'
import { UploadAudio } from 'pages/School/UploadAudio'
import { PerformAlert, RemoveAssessmentAlert } from 'pages/School/PerformAssessments'
import { PerformAssessmentAgain } from 'pages/School/PerformAssessment'
import { CreateTicketAlert } from 'pages/CreateTicket'
import { RemoveTicketAlert, RemoveTicketMessageAlert } from 'pages/Tickets'
import { PreviewAlert } from '.'
import { Backdrop, CircularProgress } from '@mui/material'
import { SelectStatusTypeAlert, StuckReasonAlert } from 'pages/Admin/TranscriptionSystem'
import { CreateClass2 } from 'pages/School/CreateClass'
import { AddSchoolClass, AddShortSchoolClass, DownloadStudentFileAlert, ExitEditAffiliationAlert } from 'pages/School/AffiliationManagement'
import { AffiliationSetupAlert } from 'pages/Dashboard'
import AddLearningGroup from 'pages/School/AffiliationManagement/AddLearningGroup'
import VersionMessagePopup from 'components/VersionMessagePopup'

const WrapAlert = () => {
    const { alerts, updateRoleIsPending } = useSelector(state => state.general)

    return (
        <>
            {
                alerts[alertKeys.createCoupon].open &&
                <CreateCoupon />
            }
            {
                alerts[alertKeys.createAffliation].open &&
                <CreateAffliation {...alerts[alertKeys.createAffliation]} />
            }
            {
                alerts[alertKeys.downloadStudentFile].open &&
                <DownloadStudentFileAlert {...alerts[alertKeys.downloadStudentFile]} />
            }
            {
                alerts[alertKeys.addSchoolClass].open &&
                <AddSchoolClass {...alerts[alertKeys.addSchoolClass]} />
            }
            {
                alerts[alertKeys.addLearningGroup].open &&
                <AddLearningGroup {...alerts[alertKeys.addLearningGroup]} />
            }
            {
                alerts[alertKeys.createShortClass].open &&
                <AddShortSchoolClass {...alerts[alertKeys.createShortClass]} />
            }
            {
                alerts[alertKeys.exitEditAffiliation].open &&
                <ExitEditAffiliationAlert {...alerts[alertKeys.exitEditAffiliation]} />
            }
            {
                alerts[alertKeys.performAssessment].open &&
                <PerformAlert />
            }
            {
                alerts[alertKeys.createTestTaker].open &&
                <CreateTestTaker />
            }
            {
                alerts[alertKeys.schoolSetup].open &&
                <AffiliationSetupAlert />
            }
            {
                alerts[alertKeys.createTestTakers].open &&
                <CreateTestTakers />
            }
            {
                alerts[alertKeys.createGrade].open &&
                <CreateGrade />
            }
            {
                alerts[alertKeys.createClass].open &&
                <CreateClass />
            }
            {
                alerts[alertKeys.createClass2].open &&
                <CreateClass2 />
            }
            {
                alerts[alertKeys.initializeAssessment].open &&
                <InitializeConfirmation />
            }
            {
                alerts[alertKeys.backTo].open &&
                <BackToConfirmation />
            }
            {
                alerts[alertKeys.recordInstructions].open &&
                <RecordInstructions />
            }
            {
                alerts[alertKeys.uploadAudio].open &&
                <UploadAudio />
            }
            {
                alerts[alertKeys.removeAssessment].open &&
                <RemoveAssessmentAlert />
            }
            {
                alerts[alertKeys.selectStatusType].open &&
                <SelectStatusTypeAlert />
            }
            {
                alerts[alertKeys.stuckReason].open &&
                <StuckReasonAlert />
            }
            {
                alerts[alertKeys.removeTicket].open &&
                <RemoveTicketAlert />
            }
            {
                alerts[alertKeys.removeTicketMessage].open &&
                <RemoveTicketMessageAlert />
            }
            {
                alerts[alertKeys.noBalance].open &&
                <NoBalance />
            }
            {
                alerts[alertKeys.finishPerformAseessment].open &&
                <AssessmentCompletionAlert />
            }
            {
                alerts[alertKeys.performAssessmentAgain].open &&
                <PerformAssessmentAgain />
            }
            {
                alerts[alertKeys.preview].open &&
                <PreviewAlert />
            }
            {
                alerts[alertKeys.contactUs].open &&
                <CreateTicketAlert isUser />
            }
            {
                <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={updateRoleIsPending}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            }
        </>
    )
}

export default WrapAlert